<h1 class="u-sr-only">{{ 'Toolkit.Preview.Title' | translate }}</h1>
<section class="c-section c-section--first c-section--last c-section--open c-section--static u-no-pb">
	<div class="c-section__content">
		<div class="o-grid">
			<div class="o-grid__cell c-cell">
				<div class="c-card toolkit">
					<loader-overlay *ngIf="vm.loading"></loader-overlay>

					<div class="container container-narrow">
						<button class="btn-back" type="button" (click)="vm.close()">
							<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M19 12H5M12 19l-7-7 7-7"/></svg>
							{{ 'Toolkit.Common.Back' | translate }}
						</button>
						<p class="subtitle">{{ 'Toolkit.Preview.Subtitle' | translate }}</p>

						<div class="toolkit__emptyPane" *ngIf="!vm.loading && vm.error">
							<div class="toolkit__emptyTitle">{{ 'Toolkit.Preview.LoadError.Title' | translate }}</div>
							<div class="toolkit__emptyText">{{ 'Toolkit.Preview.LoadError.Text' | translate }}</div>
						</div>

						<ng-container *ngIf="!vm.loading && !vm.error && vm.item">
							<ng-container *ngIf="vm.kind === 'resource'">
								<ng-container *ngFor="let b of vm.blocks">
									<ng-container [ngSwitch]="b.type">
										<div *ngSwitchCase="'header'" class="exercise-header">
											<div class="resource-meta">
												<span class="resource-meta-item" *ngIf="vm.theme?.icon || vm.theme?.name">{{ vm.theme?.icon || '' }} {{ (vm.theme?.name || '') | translate }}</span>
												<span class="resource-meta-item" *ngIf="vm.item.durationMinutes != null">{{ vm.item.durationMinutes }} {{ 'Toolkit.Common.Minutes' | translate }}</span>
												<span class="resource-meta-item" *ngIf="vm.item.format">{{ vm.resourceFormatLabel(vm.item.format) | translate }}</span>
												<span class="resource-meta-item badge" [ngClass]="{'badge-green': vm.item.difficulty === 'easy', 'badge-amber': vm.item.difficulty !== 'easy'}" *ngIf="vm.item.difficulty">{{ vm.difficultyLabel(vm.item.difficulty) | translate }}</span>
											</div>
											<h1>{{ vm.item.title || vm.item.name || vm.item.id }}</h1>
											<p class="text-muted mt-sm" *ngIf="vm.item.summary">{{ vm.item.summary }}</p>
										</div>

									<div *ngSwitchCase="'therapist_note'" class="exercise-therapist-note">
										<div class="note-label">{{ 'Toolkit.Preview.FromTherapist' | translate }}</div>
										<p>{{ b.note }}</p>
									</div>

									<div *ngSwitchCase="'privacy_note'" class="privacy-card">
										<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#717680" stroke-width="2"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>
										<p class="text-sm text-muted">{{ 'Toolkit.Preview.Privacy' | translate }}</p>
									</div>

									<div *ngSwitchCase="'psychoeducation'" class="exercise-body">
										<div class="psychoed-content" *ngIf="vm.content?.sections?.length">
											<ng-container *ngFor="let s of vm.content.sections">
												<div class="highlight-box" *ngIf="s.type === 'highlight'" [innerHTML]="s.html"></div>
												<div *ngIf="s.type !== 'highlight'" [innerHTML]="s.html"></div>
											</ng-container>
										</div>
									</div>

									<div *ngSwitchCase="'reflections'" class="exercise-body">
										<div class="exercise-subheader">{{ 'Toolkit.Preview.Reflect' | translate }}</div>
										<div class="field-group" *ngFor="let q of b.questions; let i = index">
											<label>{{ q }}</label>
											<textarea rows="3" [disabled]="vm.isPreview || vm.isReadOnly" [(ngModel)]="vm.response['reflection_' + i]" placeholder="{{ 'Toolkit.Preview.ReflectionPlaceholder' | translate }}"></textarea>
										</div>
									</div>

									<div *ngSwitchCase="'interactive'" class="exercise-body">
										<div class="exercise-section" *ngIf="vm.content?.instructions">
											<p class="text-muted mb-md">{{ vm.content.instructions }}</p>
										</div>

										<div class="exercise-section" *ngIf="vm.content?.fields?.length">
											<ng-container *ngFor="let f of vm.content.fields">
												<h3 class="exercise-subheader" *ngIf="f.type === 'subheader'">{{ f.label }}</h3>

												<div class="field-group" *ngIf="f.type !== 'subheader'">
													<ng-container *ngIf="renderFieldByType(f) as fd">
														<label>
															{{ f.label || f.id }}
															<span *ngIf="f.required === true"> *</span>
															<span class="text-muted text-sm" *ngIf="f.required === false">(optional)</span>
														</label>

														<!-- Required by ticket: text/select + future-safe -->
														<input
															*ngIf="fd.kind === 'text'"
															type="text"
															[disabled]="vm.isPreview || vm.isReadOnly"
															[(ngModel)]="vm.response[f.id]"
															[placeholder]="f.placeholder || ''">

														<select *ngIf="fd.kind === 'select'" [disabled]="vm.isPreview || vm.isReadOnly" [(ngModel)]="vm.response[f.id]">
															<option value="">{{ 'Toolkit.Preview.SelectPlaceholder' | translate }}</option>
															<option *ngFor="let opt of (fd.options || [])" [value]="opt">{{ opt }}</option>
														</select>
														<div class="form-hint" *ngIf="fd.kind === 'select' && !(fd.options || []).length">{{ 'Toolkit.Preview.NoOptions' | translate }}</div>

														<!-- Existing extra types (kept) -->
														<textarea *ngIf="fd.kind === 'textarea'" rows="3" [disabled]="vm.isPreview || vm.isReadOnly" [(ngModel)]="vm.response[f.id]" [placeholder]="f.placeholder || ''"></textarea>
														<input *ngIf="fd.kind === 'number'" type="number" [disabled]="vm.isPreview || vm.isReadOnly" [(ngModel)]="vm.response[f.id]" [placeholder]="f.placeholder || ''">
														<input *ngIf="fd.kind === 'date'" type="date" [disabled]="vm.isPreview || vm.isReadOnly" [(ngModel)]="vm.response[f.id]">
														<input *ngIf="fd.kind === 'time'" type="time" [disabled]="vm.isPreview || vm.isReadOnly" [(ngModel)]="vm.response[f.id]">

														<div *ngIf="fd.kind === 'range'" class="slider-field">
															<span class="text-sm text-muted">{{ f.min }}</span>
															<input type="range" [disabled]="vm.isPreview || vm.isReadOnly" [min]="f.min" [max]="f.max" [(ngModel)]="vm.response[f.id]">
															<span class="slider-value">{{ vm.response[f.id] || fieldMidValue(f) }}</span>
															<span class="text-sm text-muted">{{ f.max }}</span>
														</div>

														<ng-container *ngIf="fd.kind === 'chips'">
															<div class="pattern-chips">
																<button
																	type="button"
																	class="pattern-chip"
																	[disabled]="vm.isPreview || vm.isReadOnly"
																	[class.selected]="vm.isChipSelected(f.id, opt)"
																	[attr.title]="opt.hint || null"
																	(click)="vm.selectChip(f.id, opt, $event)"
																	(pointerup)="vm.selectChip(f.id, opt, $event)"
																	*ngFor="let opt of (fd.chipOptions || [])">
																	{{ opt.label }}
																	<span class="chip-info" *ngIf="opt.hint" aria-hidden="true">i</span>
																</button>
															</div>
														</ng-container>

														<div class="form-hint" *ngIf="f.placeholder && fd.kind !== 'text' && fd.kind !== 'textarea'">{{ f.placeholder }}</div>
													</ng-container>
												</div>
											</ng-container>
										</div>
									</div>

									<div *ngSwitchCase="'cta_complete'" style="margin-top:var(--tk-space-xl); display:flex; gap:var(--tk-space-md); flex-wrap:wrap;">
										<button class="btn-primary" type="button" [disabled]="vm.submitting || vm.isReadOnly" (click)="vm.submit()">
											{{ vm.submitting ? ('Toolkit.Common.Loading' | translate) : ('Toolkit.Preview.CompleteCta' | translate) }}
										</button>
									</div>

									<div *ngSwitchCase="'preview_disabled_note'" class="preview-disabled-note">
										<p class="text-sm text-muted">{{ 'Toolkit.Preview.DisabledNote' | translate }}</p>
									</div>

									<div *ngSwitchCase="'unsupported_content'" class="preview-disabled-note">
										<p class="text-sm text-muted">{{ 'Toolkit.Preview.ContentUnavailable' | translate }}</p>
										<pre class="toolkit__detailJson" style="max-height:260px; overflow:auto;">{{ vm.item.contentJson || vm.item.content_json }}</pre>
									</div>
								</ng-container>
							</ng-container>
						</ng-container>

						<!-- Survey preview: show minimal metadata for now -->
							<div *ngIf="vm.kind === 'assessment'">
								<div class="toolkit__emptyPane">
									<div class="toolkit__emptyText">{{ 'Toolkit.Preview.Assessment.Note' | translate }}</div>
									<pre class="toolkit__detailJson" style="max-height:420px; overflow:auto;">{{ vm.item | json }}</pre>
								</div>
							</div>
						</ng-container>
					</div>
				</div>
			</div>
		</div>
	</div>
</section>
